export default __webpack_public_path__ + "static/fonts/TiemposHeadline-Light.b6d3e03.woff";